document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initCifras();
  initColorSelector();
  initFavoritos();
  initAnadirRapido();
});

function initReveal() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => obs.observe(el));
}

function initCifras() {
  const els = document.querySelectorAll('.mt-cifra[data-hasta]');
  if (!els.length) return;
  const animar = (el) => {
    const hasta = parseFloat(el.dataset.hasta) || 0;
    const dur = 1400;
    const inicio = performance.now();
    const paso = (ahora) => {
      const p = Math.min(1, (ahora - inicio) / dur);
      const valor = Math.floor(hasta * (1 - Math.pow(1 - p, 3)));
      el.textContent = valor.toLocaleString('es-ES') + (el.dataset.sufijo || '');
      if (p < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) {
    els.forEach(animar);
    return;
  }
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animar(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  els.forEach((el) => obs.observe(el));
}

function initColorSelector() {
  document.querySelectorAll('[data-mt-color-selector]').forEach((wrap) => {
    const swatches = wrap.querySelectorAll('[data-mt-swatch]');
    const img = wrap.querySelector('[data-mt-color-imagen]');
    const nombre = wrap.querySelector('[data-mt-color-nombre]');
    if (!swatches.length) return;
    swatches.forEach((sw) => {
      sw.addEventListener('click', () => {
        swatches.forEach((s) => s.classList.remove('mt-swatch--activo'));
        sw.classList.add('mt-swatch--activo');
        if (img && sw.dataset.imagen) img.src = sw.dataset.imagen;
        if (nombre) nombre.textContent = sw.dataset.nombre || '';
      });
    });
  });
}

var MT_FAVORITOS_CLAVE = 'mt_favoritos';

function mtLeerFavoritos() {
  try {
    return JSON.parse(localStorage.getItem(MT_FAVORITOS_CLAVE)) || [];
  } catch (e) {
    return [];
  }
}

function mtGuardarFavoritos(lista) {
  localStorage.setItem(MT_FAVORITOS_CLAVE, JSON.stringify(lista));
  document.dispatchEvent(new CustomEvent('mt:favoritos-actualizado', { detail: lista }));
}

function mtPintarFavoritos() {
  var favoritos = mtLeerFavoritos();
  var ids = favoritos.map(function (f) { return f.id; });
  document.querySelectorAll('[data-mt-guardar]').forEach(function (btn) {
    btn.classList.toggle('mt-tarjeta__guardar--activo', ids.indexOf(btn.dataset.id) > -1);
  });
  document.querySelectorAll('[data-mt-favoritos-contador]').forEach(function (el) {
    el.textContent = favoritos.length;
    el.hidden = favoritos.length === 0;
  });
}

function initFavoritos() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mt-guardar]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var favoritos = mtLeerFavoritos();
    var id = btn.dataset.id;
    var idx = favoritos.findIndex(function (f) { return f.id === id; });
    if (idx > -1) {
      favoritos.splice(idx, 1);
    } else {
      favoritos.push({
        id: id,
        title: btn.dataset.title || '',
        url: btn.dataset.url || '#',
        image: btn.dataset.image || '',
        price: btn.dataset.price || ''
      });
    }
    mtGuardarFavoritos(favoritos);
    mtPintarFavoritos();
  });
  mtPintarFavoritos();
  document.addEventListener('shopify:section:load', mtPintarFavoritos);
}

function initAnadirRapido() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mt-anadir-rapido]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var textoOriginal = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('No disponible');
        return r.json();
      })
      .then(function () {
        return fetch(window.Shopify.routes.root + 'cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var burbuja = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
        if (burbuja) burbuja.textContent = cart.item_count;
        btn.textContent = 'Añadido ✓';
        setTimeout(function () {
          btn.textContent = textoOriginal;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Agotado';
        setTimeout(function () {
          btn.textContent = textoOriginal;
          btn.disabled = false;
        }, 1800);
      });
  });
}
